import App from 'app/app.js';
import 'app/store/ContentStore.js';
import 'app/action/ContentChangeAction.js';

function LtTranslateDirective(ContentStore, ContentChangeAction, $interpolate, $parse) {
  return {
    restrict: 'A',
    replace: true,
    scope: true,
    link: function linkFn(scope, element, attrs) {
      // translateValues is the replacement value(s)
      var unbinders,
        translateValuesExist = !!attrs.ltTranslateValues,
        applyElementContent = function (translationKey, interpolateParams) {
          // lt-translate="RESOURCE_KEY" lt-zone="ZONE_KEY"
          var content = ContentStore.getContent(scope.zone || null, translationKey);

          if (!!content) {
            element.html(!!interpolateParams ? $interpolate(content)(scope.interpolateParams || {}) : content);
          } else {
            element.html(translationKey);
          }
        },
        updateTranslationFn = (function () {
          if (!translateValuesExist) {
            return function () {
              var unwatch = scope.$watch(
                'translationKey',
                function () {
                  if (!!scope.translationKey) {
                    applyElementContent(scope.translationKey);
                    unwatch();
                  }
                },
                false
              );
            };
          }

          return function () {
            var updateTranslations = function () {
              if (!!scope.translationKey && !!scope.interpolateParams) {
                applyElementContent(scope.translationKey, scope.interpolateParams);
              }
            };
            unbinders.push(scope.$watch('interpolateParams', updateTranslations, true));
          };
        })();

      unbinders = [ContentChangeAction.register(updateTranslationFn)];
      scope.interpolateParams = {};

      unbinders.push(
        attrs.$observe('ltZone', function (zone) {
          scope.zone = zone;
        })
      );

      unbinders.push(
        attrs.$observe('ltTranslate', function (translationKey) {
          if (translationKey.endsWith('_$COUNTRY')) {
            translationKey = ContentStore.appendCountryCode(translationKey.replace('_$COUNTRY', ''));
          }
          scope.translationKey = translationKey;
          updateTranslationFn();
        })
      );

      if (translateValuesExist) {
        unbinders.push(
          attrs.$observe('ltTranslateValues', function (interpolateParams) {
            if (interpolateParams) {
              unbinders.push(
                scope.$parent.$watch(function () {
                  angular.extend(scope.interpolateParams, $parse(interpolateParams)(scope.$parent));
                })
              );
            }
          })
        );
      }

      updateTranslationFn();

      scope.$on(
        '$destroy',
        function () {
          unbinders.forEach(function (unbinder) {
            unbinder();
          });
        }.bind(this)
      );
    }
  };
}

App.directive('ltTranslate', ['ContentStore', 'ContentChangeAction', '$interpolate', '$parse', LtTranslateDirective]);
